import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import BannerAd from '../components/BannerAd';
import CategoryFilter from '../components/CategoryFilter';
import ArticleList from '../components/ArticleList';
import TrendingArticles from '../components/TrendingArticles';
import TrendingJournalists from '../components/TrendingJournalists';
import { getArticles } from '../api/strapiClient';
import taglineImage from '../assets/single-line-introducing-onlyfreenews-tagline.png';

const PAGE_SIZE = 10;

export default function Home() {
  const [category, setCategory] = useState('All');
  const [page, setPage] = useState(1);
  const [articles, setArticles] = useState([]);
  const [pageCount, setPageCount] = useState(1);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    let cancelled = false;
    setLoading(true);
    setError(null);

    getArticles({ category, page, pageSize: PAGE_SIZE })
      .then((res) => {
        if (cancelled) return;
        setArticles(res.data || []);
        setPageCount(res.meta?.pagination?.pageCount || 1);
      })
      .catch((err) => {
        if (cancelled) return;
        setError(err.message || 'Unknown error');
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });

    return () => {
      cancelled = true;
    };
  }, [category, page]);

  const handleCategorySelect = (cat) => {
    setCategory(cat);
    setPage(1);
  };

  return (
    <main className="page page--home">
      <img
        src={taglineImage}
        alt="Introducing OnlyFreeNews"
        className="home-tagline"
      />
      <BannerAd />

      <div className="home-columns">
        <div className="home-columns__divider" />

        <h2 className="top-stories-title">Top Stories</h2>

        <div className="page__categories">
          <CategoryFilter selected={category} onSelect={handleCategorySelect} />
        </div>

        <aside className="page__headlines">
          <section className="sidebar-section">
            <h2 className="section-heading">Headlines</h2>

            {articles.length === 0 ? (
              <p className="state-message">No headlines yet.</p>
            ) : (
              <ol className="trending-list">
                {articles.slice(0, 8).map((article) => (
                  <li key={article.id} className="trending-list__item">
                    <Link
                      to={`/articles/${article.documentId}`}
                      className="trending-list__title"
                    >
                      {article.title}
                    </Link>
                  </li>
                ))}
              </ol>
            )}
          </section>
        </aside>

        <div className="page__main">
          <ArticleList
            articles={articles}
            loading={loading}
            error={error}
            page={page}
            pageCount={pageCount}
            onPageChange={setPage}
          />
        </div>

        <aside className="page__sidebar">
          <TrendingArticles articles={articles} />
          <TrendingJournalists articles={articles} />
        </aside>
      </div>

      <div className="home-bottom-columns">
        <section className="sidebar-section">
          <h2 className="section-heading">Journalist Spotlight</h2>
          <p className="state-message">Coming soon.</p>
        </section>

        <section className="sidebar-section">
          <h2 className="section-heading">Latest Podcasts</h2>
          <p className="state-message">Coming soon.</p>
        </section>
      </div>
    </main>
  );
}
